import bleph1 from "@/assets/bleph-result-1.jpg";
import bleph2 from "@/assets/bleph-result-2.jpg";
import bleph3 from "@/assets/bleph-result-3.jpg";

const images = [
  {
    src: bleph1,
    alt: "Close-up of a woman's eye area showing refined upper and lower eyelids",
    caption: "The Eye, Considered",
    note: "Anatomy of expression",
  },
  {
    src: bleph2,
    alt: "Surgeon's gloved hands holding fine instruments in an operating theatre",
    caption: "High Standards",
    note: "Hospital-grade protocols",
  },
  {
    src: bleph3,
    alt: "Side profile of an elegant woman with naturally refreshed eyes",
    caption: "Quietly Refreshed",
    note: "Yourself, simply rested",
  },
];

const Gallery = () => {
  return (
    <section id="gallery" className="py-24 md:py-32 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="max-w-2xl mb-16 md:mb-20">
          <span className="text-[10px] tracking-[0.35em] uppercase text-accent font-medium">
            The Aesthetic
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-foreground mt-6 text-balance">
            Refined, <span className="italic">restored</span>, unmistakably you.
          </h2>
          <p className="text-muted-foreground font-light leading-relaxed mt-6 max-w-lg">
            Dr Vahe's signature is the absence of a signature — eyelids that look
            naturally rested, never operated on.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {images.map((image, idx) => (
            <figure
              key={idx}
              className="group relative overflow-hidden rounded-[28px] md:rounded-[36px] bg-secondary shadow-soft"
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={image.src}
                  alt={image.alt}
                  loading="lazy"
                  width={1024}
                  height={1280}
                  className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-[1.04]"
                />
              </div>
              <figcaption className="absolute bottom-0 left-0 right-0 p-6 md:p-7 bg-gradient-to-t from-primary/85 via-primary/45 to-transparent text-primary-foreground">
                <span className="text-[10px] tracking-[0.3em] uppercase opacity-80">
                  {image.note}
                </span>
                <p className="font-display text-2xl md:text-[26px] mt-1.5">
                  {image.caption}
                </p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
